
//Regex's 
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/;

export const passwordErrorMessage = "Password must contain: One uppercase letter, One lowercase letter, One special character, One number, 8 characters minimum";

export const validateEmail = (email) => {
  if (!email) {
    return "Email is required.";
  }
  if (!emailRegex.test(email)) {
    return "Valid Email is required.";
  }
  return null;
};